import React from 'react';
import { FadeIn } from './FadeIn';
import { Star, Quote } from 'lucide-react';
import { motion } from 'framer-motion';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Los protocolos de patologías en un solo lugar. El de SII con FODMAPs es oro puro.',
    author: 'Laura P.',
    location: 'Rosario',
    initial: 'L'
  }, {
    quote: 'El guion de primera consulta fue un antes y un después. Ahora sé cómo cerrar para que el paciente vuelva.',
    author: 'Roberto M.',
    location: 'Buenos Aires',
    initial: 'R'
  }, {
    quote: "Los 12 menús del Bono 6 me ahorran una hora por semana. Las listas de compras resuelven el 'no sé qué comprar'.",
    author: 'Julia M.',
    location: 'Tucumán',
    initial: 'J'
  }, {
    quote: 'Las analogías del Bono 5 cambiaron cómo explico. Mis pacientes entienden el IG en 15 segundos.',
    author: 'Valeria L.',
    location: 'Rosario',
    initial: 'V'
  }];
  const Stars = () => <div className="flex gap-1 md:gap-1.5 text-yellow-400 mb-3 md:mb-6" data-id="element-376">
      {[...Array(5)].map((_, i) => <Star key={i} fill="currentColor" className="drop-shadow-[0_0_5px_rgba(250,204,21,0.5)] w-4 h-4 md:w-5 md:h-5" data-id="element-377" />)}
    </div>;
  return <section className="py-8 md:py-20 px-4 max-w-6xl mx-auto bg-[#0a0a0a]" data-id="element-378">
      <FadeIn data-id="element-379">
        <h2 className="text-2xl md:text-5xl font-black text-center mb-6 md:mb-14 flex items-center justify-center gap-2 md:gap-4 px-2" data-id="element-380">
          <span className="text-red-500 drop-shadow-[0_0_15px_rgba(239,68,68,0.4)]" data-id="element-381">
            ❤️
          </span>{' '}
          LO QUE DICEN LAS QUE YA LO TIENEN
        </h2>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-8" data-id="element-382">
        {testimonials.map((t, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-383">
            <motion.div whileHover={{
          y: -5
        }} className="bg-gradient-to-br from-gray-900 to-black border border-gray-800 hover:border-gray-600 rounded-2xl md:rounded-3xl p-5 md:p-8 h-full relative overflow-hidden shadow-lg transition-all" data-id="element-384">
              <Quote className="absolute top-4 right-4 md:top-6 md:right-6 text-gray-800/50 w-16 h-16 md:w-24 md:h-24 rotate-180 -z-0" data-id="element-385" />

              <div className="relative z-10 flex flex-col h-full" data-id="element-386">
                <Stars data-id="element-387" />
                <p className="text-base md:text-xl text-gray-200 mb-4 md:mb-8 italic leading-relaxed font-medium flex-grow" data-id="element-388">
                  "{t.quote}"
                </p>
                <div className="flex items-center gap-3 md:gap-4 mt-auto pt-4 md:pt-6 border-t border-gray-800/50" data-id="element-389">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-gradient-to-br from-green-400 to-green-600 rounded-full flex items-center justify-center text-black font-black text-base md:text-xl shadow-[0_0_15px_rgba(34,197,94,0.3)]" data-id="element-390">
                    {t.initial}
                  </div>
                  <div data-id="element-391">
                    <p className="font-bold text-white text-base md:text-lg" data-id="element-392">
                      {t.author}
                    </p>
                    <p className="text-xs md:text-sm text-gray-400 font-medium" data-id="element-393">
                      {t.location}
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>
          </FadeIn>)}
      </div>
    </section>;
}